exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vdatetime-fade-enter-active,\n.vdatetime-fade-leave-active {\n  -webkit-transition: opacity .4s;\n  transition: opacity .4s;\n}\n.vdatetime-fade-enter,\n.vdatetime-fade-leave-to {\n  opacity: 0;\n}\n.vdatetime-overlay {\n  position: fixed;\n  z-index: 1000;\n  background-color: rgba(53, 54, 53, 0.88);\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  padding-top: 53px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  overflow-y: scroll;\n  -webkit-transition: opacity .5s;\n  transition: opacity .5s;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-60ef3de1","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/standard/input/vue-datetime/Datetime.vue
// module id = eEKa
// module chunks = 53